export default {"src":"/_next/static/media/search.bb285dc2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};